import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const dataFlowStatusSelector = createSelector(
  [
    (state: any) => state.app.listing.aclQueryMode,
    (state: any) => state.pipelines.detailView.id,
    (state: any) => state.metrics.dashboard,
  ],
  (aclQueryMode, selectedCardID, dashboard) => {
    return {
      aclQueryMode,
      selectedCardID,
      dashboard,
    };
  },
);

type DataFlowStatusSelector = ReturnType<typeof dataFlowStatusSelector>;

function useDataFlowStatusSelector(): DataFlowStatusSelector {
  const data = useSelector(dataFlowStatusSelector);
  return data;
}

export { useDataFlowStatusSelector };
